import { BcpShellInitializer } from '@bcp/js-micro-frontends-initializer';
import { environment } from './environments/environment';
import { normalizeLegacyHashUrl } from './utils/normalize-legacy-hash-url.function';

if (typeof window !== 'undefined') {
  (window as any).pdfWorkerSrc = '/assets/pdfjs/pdf.worker.js';
}

(globalThis as any).environmentsGlobal = {
  hash: false
};

normalizeLegacyHashUrl();

new BcpShellInitializer()
  .withUrl(`${environment.URL_METADATA_MICROFRONTEND}`)
  .addModuleFederationSupport()
  .init()
  .catch(() => console.error("An error occurred during initialization."))
  .then(_ => import('./bootstrap'))
  .catch((__) => console.error("An error occurred during bootstrap.",__));
